import {
  ADD_WORK,
  ADD_WORK_FAILURE,
  ADD_WORK_SUCCESS,
  DELETE_WORK,
  DELETE_WORK_FAILURE,
  DELETE_WORK_SUCCESS,
  EDIT_WORK,
  EDIT_WORK_FAILURE,
  EDIT_WORK_SUCCESS,
  GET_ALL_PAGE_WORKS,
  GET_ALL_PAGE_WORKS_FAILURE,
  GET_ALL_PAGE_WORKS_SUCCESS,
  GET_WORK,
  GET_WORK_FAILURE,
  GET_WORK_SUCCESS,
  EDIT_PAGE_WORK_FAILURE,
  EDIT_PAGE_WORK_SUCCESS,
  EDIT_PAGE_WORK
} from "./actionTypes";
 
export const editPageWork = (payload) => {
  return {
    type: EDIT_PAGE_WORK,
    payload: payload,
  };
}

export const editPageWorkSuccess = (payload) => {
  return {
    type: EDIT_PAGE_WORK_SUCCESS,
    payload: payload,
  };
}

export const editPageWorkFailure = (error) => {
  return {
    type: EDIT_PAGE_WORK_FAILURE,
    payload: error,
  };
}

 
export const getAllPageWorks = (payload) => {
  return {
    type: GET_ALL_PAGE_WORKS,
    payload: payload,
  };
}

export const getAllPageWorksSuccess = (payload) => {
  return {
    type: GET_ALL_PAGE_WORKS_SUCCESS,
    payload: payload,
  };
}

export const getAllPageWorksFailure = (error) => {
  return {
    type: GET_ALL_PAGE_WORKS_FAILURE,
    payload: error,
  };
}

export const getWork = (payload) => {
  return {
    type: GET_WORK,
    payload: payload,
  };
}

export const getWorkSuccess = (payload) => {
  return {
    type: GET_WORK_SUCCESS,
    payload: payload,
  };
}

export const getWorkFailure = (error) => {
  return {
    type: GET_WORK_FAILURE,
    payload: error,
  };
}

export const addWork = (payload) => {
  return {
    type: ADD_WORK,
    payload: payload,
  };
}
export const addWorkSuccess = (payload) => {
  return {
    type: ADD_WORK_SUCCESS,
    payload: payload,
  };
}

export const addWorkFailure = (error) => {
  return {
    type: ADD_WORK_FAILURE,
    payload: error,
  };
}

export const editWork = (payload) => {
  return {
    type: EDIT_WORK,
    payload: payload,
  };
}
export const editWorkSuccess = (payload) => {
  return {
    type: EDIT_WORK_SUCCESS,
    payload: payload,
  };
}

export const editWorkFailure = (error) => {
  return {
    type: EDIT_WORK_FAILURE,
    payload: error,
  };
}

export const deleteWork = (payload) => {
  return {
    type: DELETE_WORK,
    payload: payload,
  };
}
export const deleteWorkSuccess = (payload) => {
  return {
    type: DELETE_WORK_SUCCESS,
    payload: payload,
  };
}

export const deleteWorkFailure = (error) => {
  return {
    type: DELETE_WORK_FAILURE,
    payload: error,
  };
}
